var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Pause",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <title>icon_library</title>
  <g id="svg-fg">
    <path d="M41.11,45.23a1.88,1.88,0,0,1-2-1.69V20.31a2.06,2.06,0,0,1,4,0V43.54A1.88,1.88,0,0,1,41.11,45.23Z"/>
    <path d="M41.11,19.12a1.41,1.41,0,0,1,1.52,1.19v9.42h0v13.8a1.57,1.57,0,0,1-3,0V34.12h0V20.31a1.41,1.41,0,0,1,1.52-1.19m0-1a2.38,2.38,0,0,0-2.52,2.19V34.2h0v9.33a2.55,2.55,0,0,0,5,0V29.65h0V20.31a2.38,2.38,0,0,0-2.52-2.19Z"/>
    <path d="M22.89,45.38a1.88,1.88,0,0,1-2-1.69V20.46a1.88,1.88,0,0,1,2-1.69,1.88,1.88,0,0,1,2,1.69V43.69A1.88,1.88,0,0,1,22.89,45.38Z"/>
    <path d="M22.89,19.27a1.41,1.41,0,0,1,1.52,1.19v9.42h0v13.8a1.41,1.41,0,0,1-1.52,1.19,1.41,1.41,0,0,1-1.52-1.19V34.27h0V20.46a1.41,1.41,0,0,1,1.52-1.19m0-1a2.38,2.38,0,0,0-2.52,2.19V34.35h0v9.33a2.38,2.38,0,0,0,2.52,2.19,2.38,2.38,0,0,0,2.52-2.19V29.8h0V20.46a2.38,2.38,0,0,0-2.52-2.19Z"/>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/assets/icons/pause.svg